import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';

const DistributionForRejectionMessagesChart = ({ rejecteds }) => {
  const distributionForRejectionMessagesChart = () => {

    const formattedData = rejecteds?.map((item) => ({
      count: item.count,
      type: `${item.type} (${item.count})`
    }));

    const chart = new Chart({
      container: 'distribution-for-rejection-messages',
      autoFit: true,
      height: 400,
    });

    chart.options({
      type: 'interval',
      data: formattedData,
      coordinate: { transform: [{ type: 'transpose' }] }, // Esto hace el gráfico horizontal
      encode: {
        x: 'count',
        y: 'type',
        color: 'type',
      },
      scale: {
        color: {
          range: [
            '#6950E8', '#F4A261', '#8F6FF7', '#D5A1F2', '#9A6BFF',
            '#C7A4FF', '#7A4DD4', '#BCA4E7', '#6B4CF7', '#B7A7E6',
            '#5F1DB1', '#B9A3F7', '#5733B8', '#F4B392', '#4527A0',
            '#B2A0E3', '#3A1A8C', '#EED5FF', '#A088D1', '#F4A75E',
          ],
        },
      },
      legend: {
        color: {
          position: 'right',
          layout: {
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          },
          itemMarker: 'square',
          itemMarkerSize: 14,
          itemLabelFontSize: 14,
        },
      },
      axis: {
        x: {
          line: true,
          tick: true,
          label: true,
          title: false,
        },
        y: {
          title: false,
          label: false,
          style: {
            labelFontSize: 14,
            labelFill: '#444',
          },
        },
      },
      tooltip: {
        title: 'Rechazos',
        items: [
          { channel: 'y', name: 'Tipo' }
        ],
      }
    });

    chart.render();

  }
  useEffect(() => {
    if (rejecteds && rejecteds.length > 0)
      distributionForRejectionMessagesChart();

  }, [rejecteds]);

  return (
    <div id={'distribution-for-rejection-messages'} style={{ width: '100%' }}></div>
  );
}

export default DistributionForRejectionMessagesChart;